import { createEvent } from './createEvent'

type StarClickedProperties = {
  id: string
  fid: string
  component: string
}

const createStarClickedEvent = createEvent<StarClickedProperties>

export const addModelStarClicked = createStarClickedEvent(
  'Add Model Star Clicked',
)

export const removeModelStarClicked = createStarClickedEvent(
  'Remove Model Star Clicked',
)

export const addTrendStarClicked = createStarClickedEvent(
  'Add Trend Star Clicked',
)

export const removeTrendStarClicked = createStarClickedEvent(
  'Remove Trend Star Clicked',
)

type MenuClickedProperties = {
  title: string
}
export const menuClicked = createEvent<MenuClickedProperties>('Menu Clicked')
